import { Box } from '@hivebrite/design-system/Box';

import { partnersImageRecommendedSize } from 'hb-builder/components/BuilderComponents/constants/imageSizes';
import DeleteItemModal from 'hb-builder/components/common/modal/DeleteItemModal';
import CheckboxSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/CheckboxSetting';
import EditImageSource from 'hb-builder/components/common/SettingsLibrary/CommonSettings/EditImageSource';
import TextSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/TextSetting';
import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import SettingBlock from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/SettingBlock';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { PartnersItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/partnersItemAttributes';

interface ContentItemProps
  extends ComponentSettingsTab<PartnersItemAttributes> {
  componentName: string;
  oneItemOnly: boolean;
  removeItemOpen: (id: string) => void;
}

const ContentItem = ({
  componentName,
  item: partner,
  onChange,
  oneItemOnly,
  removeItemOpen,
}: ContentItemProps) => (
  <SettingBlock boxProps={{ mt: 1, mb: 4 }}>
    <InputTitle label={__('Image')} />
    <Box my={2}>
      {s__(
        'Builder|Recommended %{size}px. The file must not exceed 2.5 MB',
      ).i__({
        size: partnersImageRecommendedSize,
      })}
    </Box>
    <EditImageSource
      hasImage={partner.attributes?.partnerImage}
      id={partner.id}
    />
    <Box mt="6px">
      <InputTitle label={__('Alternative text')} />
    </Box>
    <TextSetting
      dataTestId="partner-alt-text-setting"
      item={partner}
      onChange={onChange}
      placeholder={__('Enter alternative text')}
      description={__("This will appear if the image can't be displayed")}
      settingKey="partnerImageAlt"
      width="100%"
    />
    <InputTitle label={__('Hyperlink')} />
    <Box my={2}>
      {s__(
        'Builder|Link on which the user will land if the user clicks on the logo',
      )}
    </Box>
    <TextSetting
      item={partner}
      onChange={onChange}
      placeholder={__('Enter URL')}
      settingKey="partnerImageUrl"
      width="100%"
    />
    <CheckboxSetting
      item={partner}
      onChange={onChange}
      settingKey="openInNewTab"
      title={s__('Builder|Open link in a new tab')}
    />
    <DeleteItemModal
      id={partner.id}
      itemName={componentName}
      isDisabled={oneItemOnly}
      onConfirm={() => removeItemOpen(partner.id)}
    />
  </SettingBlock>
);

export default ContentItem;
